// การซ่อน/แสดง sidebar ถูกขับด้วยคลาสบน <body> กับตัวแปร CSS --sidebar-offset
// (ดู scss/custom.scss และ scss/panels/_sidebar.scss) ไม่ได้อยู่ใน state ของ React
// รวมไว้ที่เดียวเพราะมีสองที่ที่ต้องสั่ง: ปุ่มแฮมเบอร์เกอร์ใน Header และหน้าจอเต็มที่ป้อมยาม

// จอเล็กกับหน้าที่ตั้ง sidebar-offset ใช้ sidebar แบบสไลด์ทับ ไม่ได้กินพื้นที่หน้าจอ
// จึงสลับด้วยคลาส sidebar-show คนละตัวกับ sidebar-hide ของจอใหญ่
const usesOverlay = () =>
  window.matchMedia('(max-width: 991px)').matches ||
  document.body.classList.contains('sidebar-offset');

export const isSidebarHidden = () =>
  usesOverlay()
    ? !document.body.classList.contains('sidebar-show')
    : document.body.classList.contains('sidebar-hide');

export const setSidebarHidden = (hidden) => {
  const body = document.body;

  if (usesOverlay()) {
    body.classList.toggle('sidebar-show', !hidden);
    return;
  }

  body.classList.toggle('sidebar-hide', hidden);

  // .main อ่านระยะเยื้องซ้ายจากตัวแปรนี้ ต้องรีเซ็ตเป็น 0 ตอนซ่อน
  // ไม่งั้นเนื้อหาจะยังเว้นที่ว่างไว้ให้ sidebar ที่หายไปแล้ว
  const varName = document.documentElement.classList.contains('islamic-rtl')
    ? '--sidebar-rtl-offset'
    : '--sidebar-offset';

  if (hidden) document.documentElement.style.setProperty(varName, '0px');
  else document.documentElement.style.removeProperty(varName);
};

export const toggleSidebar = () => setSidebarHidden(!isSidebarHidden());
